import React from 'react';
import {Button, Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, Typography} from '@mui/material';
import { withStyles } from "@mui/styles";
import {ResetIcon} from '../../../helpers/Icons'
import {makeDefaultColumnSelection} from "../../pages/explore/items/table/TableDefinition";
import CloseIcon from "@mui/icons-material/Close";
import {ExpandLess} from "@mui/icons-material";

const styles = {
  columnControls: {
    display: 'flex',
    marginTop: '1em',
    padding: '0em 1em 1em',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: '4px',
    overflow: 'visible',
    position: 'relative',
    backgroundColor: '#ffffff'
  },
  label: {
    flexShrink: 0,
    fontSize: '0.85rem',
    // padding: '0 4px',
    marginTop:'-12px',
    position: 'absolute',
    backgroundColor: 'inherit',
    borderRadius: '4px',
    border: '1px solid rgba(0, 0, 0, 0)',
    '&:hover': {
      border: '1px solid rgba(0, 0, 0, 0.23)',
    },
    '&> button':{
      // textTransform: 'none',
      padding: '0px 4px',
      fontWeight: 500,
      fontSize: '0.85em',
      color: 'rgba(0, 0, 0, 0.87)'
    }
  },
  controlContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap'
  },
  columnsBox: {
    paddingTop: '0.5em',
    justifyContent: 'space-around'
  },
  columnCheckbox: {
  },
  columnLabel: {minWidth: '7.25em', flex: 1},
  buttonBox: {
    flexGrow: 1,
    flexBasis: '100%',
    marginRight:'auto',
    alignSelf: 'start',
    textAlign: 'start',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.5em',
  },
  resetButton: {
    flexShrink: 0,
    fontSize: '0.7225rem',
    height: '2.75em',
    alignSelf: 'end',
    padding: '0 1em',
    minWidth: '150px',
    color: 'rgba(0, 0, 0, 0.87)',
    borderColor: 'rgba(0, 0, 0, 0.23)'
  },
};

function ColumnControls(props) {
  const {open, setOpen, columns, visibleColumns, toggleColumnVisibility, setVisibleColumns, classes} = props;

  const getLabel = (col) => {
    let header = col.header;
    if(Array.isArray(header)){
      return header.length > 0 ? header[0].label : "";
    }else{
      return header.label;
    }
  };

  const resetColumns = () => {
    setVisibleColumns(makeDefaultColumnSelection(columns));
  };

  return (
    <FormControl id="columnsMenu" className={classes.columnControls}>
      <FormLabel className={classes.label} component="div">
        <Button onClick={() => setOpen(!open)}>Show/Hide Columns<ExpandLess size="small" variant="outlined" style={{fontSize: '1rem'}} /></Button>
      </FormLabel>
      <FormGroup row={true} className={classes.columnsBox}>
        {columns.map((col) => {
          if(col.enabled){
            return (
              <FormControlLabel key={col.key} className={classes.columnLabel} control={
                <Checkbox className={classes.columnCheckbox} checked={visibleColumns[col.key]} onChange={() => toggleColumnVisibility(col.key)}/>
              } label={<Typography style={{fontSize: '0.85em', textTransform: 'capitalize'}}>{getLabel(col) || col.key}</Typography>} />
            );
          }
          return null;
        })}
      </FormGroup>
      <div className={classes.buttonBox}>
        <Button
          onClick={resetColumns}
          className={classes.resetButton}
          variant="outlined"
          startIcon={<ResetIcon />}
        >
          Reset Columns
        </Button>
        <Button
          onClick={() => setOpen(!open)}
          className={classes.resetButton}
          variant="outlined"
          startIcon={<CloseIcon />}
        >
          Close
        </Button>
      </div>
    </FormControl>
  );
}

export default withStyles(styles)(ColumnControls)
